import { useTranslations } from "use-intl";
import { ClockCounterClockwiseIcon } from "@phosphor-icons/react";

import { usePreviousCitySearches } from "@/app/lib/hooks/usePreviousSearches";
import type { FindCitiesCity } from "@/app/lib/types/codegen";
import { SearchResultList, SearchResultButton } from "./SearchResultList";

type Props = {
  onClick: (location: FindCitiesCity) => void;
};

export function LastSearchedCityList({ onClick }: Props) {
  const t = useTranslations();
  const { previousSearches, removePreviousSearch } = usePreviousCitySearches();

  return (
    <>
      {previousSearches?.length > 0 ? (
        <SearchResultList
          heading={t("hotels.search.lastSearched")}
          data={previousSearches}
          getItemKey={(city) => city.id}
          renderItem={(city) => (
            <SearchResultButton
              icon={ClockCounterClockwiseIcon}
              primaryText={city.name}
              secondaryText={city.countryName}
              onClick={() => onClick(city)}
              onRemove={() => removePreviousSearch(city.id)}
            />
          )}
        />
      ) : null}
    </>
  );
}
